module.exports = __webpack_public_path__ + "img/gdpvendome.b32460de.jpg";